export enum IterationType {
  UTD = "UTD",
  // Смета (СМР) — сопоставление позиций сметы с НСИ (KRE-707)
  SMR = "SMR",
}
